import { render, staticRenderFns } from "./wechatPopup.vue?vue&type=template&id=368e5838"
import script from "./wechatPopup.vue?vue&type=script&lang=ts"
export * from "./wechatPopup.vue?vue&type=script&lang=ts"
import style0 from "./wechatPopup.vue?vue&type=style&index=0&id=368e5838&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports